export interface UserObject {
  _id: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  country?: string;
  birthDate?: Date;
  address?: string;
  city?: string;
  zipCode?: string;
  language?: string;
  password?: string;
  role?: 'user' | 'admin' | 'skycop';
  isVerified?: boolean;
  verificationToken?: string;
  verificationTokenExpiration?: Date;
  resetToken?: string;
  resetTokenExpiration?: Date;
  isBlocked?: boolean;
  isUserInfoComplete?: boolean;
  googleId?: string;
  avatarUrl?: string;
  paymentInfo?: {
    bankCountry?: string;
    currency?: string;
    iban?: string;
    bankTitle?: string;
    bankAddress?: string;
    firstName?: string;
    lastName?: string;
    userCountry?: string;
  };
}

export const emptyUser: UserObject = {
  _id: '',
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  country: '',
  birthDate: new Date(Date.now()),
  address: '',
  city: '',
  zipCode: '',
  language: '',
  password: '',
  role: 'user',
  isVerified: false,
  verificationToken: '',
  verificationTokenExpiration: new Date(Date.now()),
  resetToken: '',
  resetTokenExpiration: new Date(Date.now()),
  isBlocked: false,
  isUserInfoComplete: false,
  paymentInfo: {
    bankCountry: '',
    currency: '',
    iban: '',
    bankTitle: '',
    bankAddress: '',
    firstName: '',
    lastName: '',
    userCountry: '',
  },
};
